// extracted by mini-css-extract-plugin
module.exports = {"morebtn":"XdLFM","isNoLink":"tez7p","loadLess":"u9Yms","lighBgBtn":"QWGrq","disable":"Z7n9b"};